var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileLinesRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 62,
    viewBox: "0 0 47 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-lines-regular 1",
    clipPath: "url(#clip0_929_17643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.75 56.1875C6.68437 56.1875 5.8125 55.3156 5.8125 54.25V7.75C5.8125 6.68437 6.68437 5.8125 7.75 5.8125H27.125V15.5C27.125 17.6434 28.8566 19.375 31 19.375H40.6875V54.25C40.6875 55.3156 39.8156 56.1875 38.75 56.1875H7.75ZM7.75 0C3.47539 0 0 3.47539 0 7.75V54.25C0 58.5246 3.47539 62 7.75 62H38.75C43.0246 62 46.5 58.5246 46.5 54.25V18.709C46.5 16.6504 45.6887 14.6766 44.2355 13.2234L33.2645 2.26445C31.8113 0.811328 29.8496 0 27.791 0H7.75ZM14.5312 31C12.9207 31 11.625 32.2957 11.625 33.9062C11.625 35.5168 12.9207 36.8125 14.5312 36.8125H31.9688C33.5793 36.8125 34.875 35.5168 34.875 33.9062C34.875 32.2957 33.5793 31 31.9688 31H14.5312ZM14.5312 42.625C12.9207 42.625 11.625 43.9207 11.625 45.5312C11.625 47.1418 12.9207 48.4375 14.5312 48.4375H31.9688C33.5793 48.4375 34.875 47.1418 34.875 45.5312C34.875 43.9207 33.5793 42.625 31.9688 42.625H14.5312Z",
    fill: "#AA182C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_929_17643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.5,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileLinesRegular);
export default __webpack_public_path__ + "static/media/file-lines-regular.7a79db8d09c2af19c1b074ae757d2be0.svg";
export { ForwardRef as ReactComponent };